import Lottie from 'lottie-react';
import { FlexContainerVertical } from '../../../../../../layout/Flex';
import loader from './loader.json';

export const EmployeeAppLoader = ({
  height = 300
}: {
  height?: number | string;
}) => {
  return (
    <Lottie
      animationData={loader}
      style={{
        height
      }}
    />
  );
};

export const EmployeeAppPageLoader = () => {
  return (
    <FlexContainerVertical
      fullHeight
      fullWidth
      alignItems="center"
      justifyContent="center"
    >
      <EmployeeAppLoader height={350} />
    </FlexContainerVertical>
  );
};
